import React, { useContext } from 'react';
import { Box, Paper } from '@mui/material';

import { SiteButton } from '../buttons/site-button';
import { EditableLabel } from '../editable-label';
import { StepImageCropper } from '../step-image-cropper'
import { updateAction } from '../action/updateAction';
import { RecordContext } from '../record-context';
import { useCustomParam } from '../../hooks/use-custom-param';

import { Label } from '../label';
import { StepMenu } from '../step-menu';
import { StepImageMenu } from '../step-image-menu';
import { StepSeparator } from '../step-separator';
import { detectURLs } from '../../utils';
import { useStyles } from './styles';

export const Step = ({ step, index, dragArea, isDraggable, setIsDragDisabled }) => {
  const classes = useStyles();
  const { record, recordDispatch } = useContext(RecordContext);
  const isEdit = false;

  const handleSave = (text) => {
    const arr = record.arr.map(item => item.id === step.id
        ? { ...item, name: text }
        : item
    );
    recordDispatch(updateAction({...record, arr, needSave: true}));
  }

  return (
    <Box>
      { isEdit && <StepSeparator index={index} isHide={isDraggable}/> }
      <Box mt={3} mb={3} key={index} {...dragArea}>
        <Paper elevations={8}>
          <Box style={{paddingBottom: '1px'}}>
            <Box p={2} display='flex' justifyContent='space-between'>
              <Box display='flex' alignItems='center'>
                <Box className={classes.stepNumber}>{index + 1}</Box>
                <Box display='flex' alignItems='center' mr={1}>
                  { isEdit ? <EditableLabel label={step.name} handleSave={handleSave}/>
                    : <Label label={step.name} /> }
                </Box>
                { detectURLs(step.name)
                && detectURLs(step.name).map((url, index) => <SiteButton key={index} url={url} />)}
              </Box>
              { isEdit &&
                <Box display='flex'>
                  <StepImageMenu step={step} index={index}/>
                  <StepMenu step={step} index={index}/>
                </Box>
              }
            </Box>
            {step.imageURL &&
            <Box mb={3} className={classes.imageWrap}>
              {
                isEdit ?
                  <StepImageCropper image={step.imageURL} step={step} setIsDragDisabled={setIsDragDisabled} /> :
                  <img style={{width: "100%"}} src={step.imageURL} alt={step.name}/>
              }
            </Box>}
          </Box>
        </Paper>
      </Box>
    </Box>
  )
}